// CartTotal.js
import React, { useEffect } from "react";
import { auth } from "../../../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { useCart } from "contexts/CartContext";
import { formactPrice } from "functions";
import {
  StyledCartTotal,
  QuantityPrice,
  Total,
  TotalTitle,
  TotalValue,
  WalletButton,
} from "./styles";

const CartTotal = () => {
  const navigate = useNavigate();
  const { cart, totalCart } = useCart();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        // User is logged in
        // You can perform actions for a logged-in user here
      } else {
        // User is logged out
        // You can perform actions for a logged-out user here
      }
    });

    // Clean up the observer when the component unmounts
    return () => unsubscribe();
  }, []);

  const handleCheckout = () => {
    // Check if the user is authenticated based on currentUser
    const currentUser = auth.currentUser;
    if (currentUser) {
      // User is authenticated, proceed to checkout
      navigate("/checkout");
    } else {
      // User is not authenticated, redirect to login
      navigate("/login");
    }
  };

  return (
    <StyledCartTotal>
      <Total>
        <TotalTitle>Total</TotalTitle>
        <TotalValue>{totalCart()}</TotalValue>
      </Total>
      <QuantityPrice>
        {cart.map((item) => {
          return (
            <li key={item.id}>
              <p>{`${item.quantidade_carrinho.toString()} x ${formactPrice(
                item.preco
              )}`}</p>
            </li>
          );
        })}
      </QuantityPrice>
      <WalletButton onClick={handleCheckout}>Proceed to Checkout</WalletButton>
    </StyledCartTotal>
  );
};

export default CartTotal;
